module.exports = __webpack_public_path__ + "static/media/erp.ae4d9260.png";